import React, { useState } from 'react';
import { Modal, Form, Button, Alert } from 'react-bootstrap';
import { checkProductExists } from '../../utils/Product';

const NameChangeModal = ({ show, onHide, onConfirm, currentName = "" }) => {
  const [newName, setNewName] = useState(currentName);
  const [isChecking, setIsChecking] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!newName.trim()) {
      setError("Product name is required");
      return;
    }

    setIsChecking(true);
    setError("");

    try {
      // Check if product with this name already exists
      const existsResponse = await checkProductExists(newName.trim());
      
      if (existsResponse.exists) {
        setError("A product with this name already exists. Please choose a different name.");
        setIsChecking(false);
        return;
      }

      // If name is unique, proceed with confirmation
      onConfirm(newName.trim());
      onHide();
      
    } catch (error) {
      console.error("Error checking product existence:", error);
      setError("Unable to verify product name. Please try again.");
    } finally {
      setIsChecking(false);
    }
  };

  const handleClose = () => {
    setNewName(currentName); // Reset to original name
    setError(""); // Clear any errors
    onHide();
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Create New Product Draft</Modal.Title>
      </Modal.Header>
      
      <Modal.Body>
        <div className="mb-3">
          <p className="text-muted">
            This product is sourced from Shopify and cannot be directly modified. 
            To save changes, we'll create a new draft product with your modifications.
          </p>
          <p className="text-muted mb-4">
            Please provide a new name for the draft product:
          </p>
        </div>
        
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>Product Name <span className="text-danger">*</span></Form.Label>
            <Form.Control
              type="text"
              value={newName}
              onChange={(e) => {
                setNewName(e.target.value);
                setError(""); // Clear error when user starts typing
              }}
              placeholder="Enter new product name"
              required
              autoFocus
              disabled={isChecking}
            />
            {error && (
              <Alert variant="danger" className="mt-2 mb-0">
                <small>{error}</small>
              </Alert>
            )}
          </Form.Group>
        </Form>
      </Modal.Body>
      
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose} disabled={isChecking}>
          Cancel
        </Button>
        <Button 
          variant="dark" 
          onClick={handleSubmit}
          disabled={!newName.trim() || isChecking}
        >
          {isChecking ? (
            <>
              <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              Checking...
            </>
          ) : (
            "Create Draft"
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default NameChangeModal;
